import { getAuthData } from '../../helpers/url';

export default function initializePendo() {
  const { user } = getAuthData();
  if (window.pendo) {
    window.pendo.initialize({
      visitor: {
        id: user.uuid,
        role: user.role,
        journey: 'alef_student',
        school: user.school.uuid,
        tenant: user.tenant,
      },
      account: {
        id: `${user.school.uuid}_${user.tenant}_${user.role}`,
      },
    });
  }
}
